import React, { useState, useEffect } from "react";
import { Search } from "react-feather";
import _ from 'lodash'
import TextInput from './TextInput'

const SearchObjectFilter = ({ dataSet, setFilteredData, path, pathProperty, subProperty, hasSearchTerm, placeholder, size, width, isClearable, setSearchTerm: propagateSearchTerm, doesntExist }) => {

	const [searchTerm, setSearchTerm] = useState("")

	useEffect(() => {
		handleSearch(searchTerm)
		hasSearchTerm(searchTerm ? true : false)
	}, [searchTerm])

	const setPath = (datum) => {
		let pathType = typeof path
		switch (pathType) {
			case "string":
				return datum[path]

			case "object":
				let searchableString = ""
				path.forEach((locater) => {
					let stringToAdd = _.get(datum, locater)
					searchableString = searchableString + ' ' + stringToAdd
				})
				return searchableString
			default:
				break;
		}
	}

	const handleSearch = (searchTerm) => {
		let searchTermArray = searchTerm.toLowerCase().split(" ")
		let newFilteredData = []
		if (!dataSet || !searchTerm) {
			return;
		}

        const dataToBeFiltered = pathProperty ? dataSet[pathProperty] : dataSet
		newFilteredData = dataToBeFiltered.filter((datum) => {
            const datumTobeUsed = subProperty ? datum[subProperty] : datum
			let formattedDatum = setPath(datumTobeUsed).toLowerCase()
			let verify = searchTermArray.map((term) => {
				if (formattedDatum.includes(term)) {
					return true
				} else {
					return false
				}
			})
			if (verify.includes(false) === false) {
				return datum
			}
		})
		setFilteredData(newFilteredData)
		if (propagateSearchTerm) {
			propagateSearchTerm({ searchTerm, filteredData: newFilteredData })
		}
	}

	return (
		<TextInput
			type="search"
			placeholder={placeholder}
			onChange={e => setSearchTerm(e.target.value)}
			size={size}
			width={width}
			icon={<Search />}
			clearText={() => setSearchTerm("")}
			isClearable={isClearable}
			value={searchTerm}
		>
		
		</TextInput>
	);
}

export default SearchObjectFilter;
